/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/alt-text */
// TODO: Update jsx-a11y
import React from 'react';
import PropTypes from 'prop-types';
import { SvgIcon, Typography } from '@mui/material';

import useSelector from 'components/Booking-new/hooks';
import { pushGTMChooseLocationEvent } from 'utils/gtm';
import { useLocationStep } from 'components/Booking-new/utils/steps/location';

import { DS_FlagshipLabel, DS_LocationContact } from 'mui/components/sections/DS_LocationHero/elements';
import { ReactComponent as ChevronRight } from 'mui/assets/icons/chevron-right.svg';

import DS_LocationTimes from 'mui/components/sections/DS_FindInMap/elements/DS_LocationTimes';
import { ReactComponent as Clock } from 'mui/assets/icons/clock.svg';

import { ReactComponent as GivingMoneyIcon } from 'mui/assets/icons/giving-money.svg';
import WaitlistLink from '../../../../Time/Variants/components/WaitlistLink';
import { LocationType } from '../../types';
import { StyledButtonWrapper } from '../../../../../../../../mui/components/sections/DS_LocationHero/elements/DS_BookAppointmentButton/styles';
import DS_ButtonLink from '../../../../../../../../mui/components/elements/DS_ButtonLink';

import {
  StyledLocationContainer,
  StyledArrowWrapper,
  StyledDetailsWrapper,
  StyledDistancePlaceholder,
  StyledFlagshipLabelWrapper,
  StyledLocationContactWrapper,
  StyledLocationHeader,
  StyledNoDates,
  StyledWrapperDiscount,
} from './styles';

const Location = React.forwardRef(
  (
    {
      location,
      distancePlaceholder,
      selectedLocationState,
      useFlagshipStoreLabel,
      waitlistButtonLabelLT,
      showTimeSlots,
      noDatesAvailableLT,
      confirmationDialogLabelLT,
      cancelDialogLabelLT,
      slotsInfo,
      loading,
      shouldPersonalDataCollected,
      filtersDatesProps,
      impressClinic,
      useDiscountOnFlagship,
      discountFlagshipText,
    },
    ref,
  ) => {
    const { results } = useSelector(state => ({
      freeParking: state?.config?.freeParking,
      funnelType: state?.config?.funnelType,
      service: state?.config?.service,
    }));
    const { selectLocation } = useLocationStep();
    const funnelType = results?.funnelType;
    const { address, heading, distanceInKm, flagshipStoreLabel } = location;

    const [selectedLocation, setSelectedLocation] = selectedLocationState;
    const isSelected = selectedLocation && location.id === selectedLocation.id;

    const handleLocationChange = () => {
      pushGTMChooseLocationEvent(location.code, funnelType);
      // test
      setSelectedLocation(location);
      selectLocation(location);
    };

    const {
      firstAvailableDay,
      firstAvailableTime,
      fourAvailableTime,
      firstSlot,
      secondSlot,
      handleTimeSelect,
      handleAddMeToWaitList,
      filteredDates,
      handleGTMAppointmentTimeSelectedEvent,
    } = (location.code !== 'SHP' && slotsInfo?.[location.code]) || {};

    const shownSlots = { [firstAvailableDay]: fourAvailableTime };

    return (
      <StyledLocationContainer
        ref={ref}
        isSelected={isSelected}
        onClick={!showTimeSlots ? handleLocationChange : undefined}
        className={isSelected && 'isSelected'}
        data-qa="location-card-mobile"
      >
        {useDiscountOnFlagship && discountFlagshipText && flagshipStoreLabel && (
          <StyledWrapperDiscount>
            <SvgIcon component={GivingMoneyIcon} inheritViewBox={true}></SvgIcon>
            <Typography variant="DS_copySmallRegular" component="p">
              {discountFlagshipText}
            </Typography>
          </StyledWrapperDiscount>
        )}

        <StyledLocationHeader>
          {distanceInKm && (
            <StyledDistancePlaceholder variant="DS_copySmallRegular" component="p">
              {distanceInKm}km {distancePlaceholder}
            </StyledDistancePlaceholder>
          )}
          <StyledFlagshipLabelWrapper>
            <DS_FlagshipLabel
              label={flagshipStoreLabel}
              shouldUseLabel={impressClinic || useFlagshipStoreLabel}
              isLocationFlagship={flagshipStoreLabel}
              impressClinic={impressClinic}
            />
          </StyledFlagshipLabelWrapper>
        </StyledLocationHeader>

        <StyledDetailsWrapper>
          <StyledLocationContactWrapper>
            <DS_LocationContact heading={heading} address={address} />
          </StyledLocationContactWrapper>
          {!showTimeSlots && !impressClinic ? (
            <StyledArrowWrapper>
              <SvgIcon component={ChevronRight} inheritViewBox={true} sx={{ fontSize: 32 }}></SvgIcon>
            </StyledArrowWrapper>
          ) : null}
        </StyledDetailsWrapper>
        {showTimeSlots && !loading && !firstAvailableTime && (
          <StyledNoDates>
            <Typography component="p" variant="DS_copyMediumRegular">
              {noDatesAvailableLT}
            </Typography>
            <WaitlistLink
              buttonVariant="text"
              buttonSize={false}
              iconPlacement={true}
              buttonIcon="Outlined Icon"
              icon={Clock}
              addMeToWaitlist={handleAddMeToWaitList}
              location={location}
              locationCode={location.code}
              waitlistButtonLabel={waitlistButtonLabelLT}
              shouldPersonalDataCollected={shouldPersonalDataCollected}
            />
          </StyledNoDates>
        )}
        {impressClinic && (
          <StyledButtonWrapper className={'fix-width impress'}>
            <DS_ButtonLink title="Prenez RDV" url="/booking/drsmile-a-impress/" />
          </StyledButtonWrapper>
        )}
        {showTimeSlots && !loading && firstAvailableTime && (
          <DS_LocationTimes
            location={location}
            handleTimeSelect={handleTimeSelect}
            confirmationDialogLabelLT={confirmationDialogLabelLT}
            cancelDialogLabelLT={cancelDialogLabelLT}
            slots={shownSlots}
            firstSlot={firstSlot}
            loading={loading}
            isSelected={isSelected}
            showButtonMore={firstSlot?.time.length > 3 || secondSlot}
            handleGTMAppointmentTimeSelectedEvent={handleGTMAppointmentTimeSelectedEvent}
            showTimeSlots={showTimeSlots}
            filteredDates={filteredDates}
            showDailyFilters={filtersDatesProps.showDailyFilters}
            filtersEmpty={filtersDatesProps.filtersEmpty}
            noDatesAvailableLT={noDatesAvailableLT}
            selectedDates={filtersDatesProps.selectedDates}
            resetDates={filtersDatesProps.resetDates}
          />
        )}
      </StyledLocationContainer>
    );
  },
);

export default Location;

Location.propTypes = {
  location: LocationType,
  distancePlaceholder: PropTypes.string,
  selectedLocationState: PropTypes.array,
  bookingButtonLabel: PropTypes.string,
  image: PropTypes.shape({
    id: PropTypes.string.isRequired,
    gatsbyImageData: PropTypes.shape({}).isRequired,
  }),
};
